module.exports = __webpack_public_path__ + "img/[握手].c1f94f50.svg";